<template>
    <button>
        <svg :width="increaseSize?increaseSize[0]:'1em'" :height="increaseSize?increaseSize[1]:'1em'" viewBox="0 0 16 16" class="bi bi-pen-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
        </svg>
    </button>
</template>

<script>

export default {
    props:["increaseSize"]
}
</script>


<style lang="scss" scoped>
svg{
    color: #939393;
}

svg:hover{
    color: #eee;
}

</style>